import { createSimpleFunctional } from '@/util'

export const VCardHeader = createSimpleFunctional('v-card-header')
